var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('img',{staticClass:"home_brand",attrs:{"src":this.image}}),_vm._v(" "),_c('h2',{staticClass:"headline headline_2",domProps:{"innerHTML":_vm._s(this.title)}}),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(this.body)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }